import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

// global icon
import Korea from "@/assets/images/layouts/header/global/korea.svg";
import America from "@/assets/images/layouts/header/global/america.svg";
import Japan from "@/assets/images/layouts/header/global/japan.svg";
import China from "@/assets/images/layouts/header/global/china.svg";
import Vietnam from "@/assets/images/layouts/header/global/vietnam.svg";
import Indonesia from "@/assets/images/layouts/header/global/indonesia.png";
import Mongolia from "@/assets/images/layouts/header/global/mongolia.png";
import Thailand from "@/assets/images/layouts/header/global/thailand.svg";

// import Malaysia             from '@/assets/images/layouts/header/global/malaysia.svg'
// import Russia               from '@/assets/images/layouts/header/global/russia.svg'

export default {
  namespaced: true,
  state: () => ({
    list: [
      // {
      //     key      : "ko",
      //     country  : "KOR",
      //     icon     : Korea,
      //     betaOpen : true,
      // },
      {
        key: "en",
        country: "America",
        icon: America,
        betaOpen: true,
        label: "English",
        isActive: false,
      },
      {
        key: "ja",
        country: "Japan",
        icon: Japan,
        betaOpen: false,
        label: "日本語",
        isActive: false,
      },
      {
        key: "zh",
        country: "China",
        icon: China,
        betaOpen: false,
        label: "中文（简体)",
        isActive: false,
      },
      {
        key: "tw",
        country: "China",
        icon: China,
        label: "中文（繁體)",
        isActive: false,
        betaOpen: false,
      },
      {
        key: "vi",
        country: "Vietnam",
        icon: Vietnam,
        betaOpen: false,
        label: "Tiếng Việt",
        isActive: false,
      },
      // {
      //     key      : "id",
      //     country  : "Indonesia",
      //     icon     : Indonesia,
      //     betaOpen : false,
      // },
      {
        key: "th",
        country: "Thailand",
        icon: Thailand,
        betaOpen: false,
        label: "ภาษาไทย",
        isActive: false,
      },
      // {
      //     key      : "mn",
      //     country  : "Mongolia",
      //     icon     : Mongolia,
      //     betaOpen : false,
      // },
      // {
      //     key      : "RUS",
      //     country  : "Russia",
      //     icon     : Russia,
      //     betaOpen : false,
      // },
    ],
    selected: cookies.get("i18n_redirected") || "en",
  }),
  mutations: {
    changeLang(state, lang) {
      state.selected = lang;
      console.log("selected", state.selected);
    },
  },
  actions: {
    langaugeClick(context, country, switchLocalePath) {
      // const country_info = this.list.find(ob => ob.key === country);
      // if(!country_info.betaOpen) return usePopupList().openBetaPopup(true);
      // const router = useRouter();
      // router.push(switchLocalePath(country_info.key))

      context.state.list.forEach((ob) => (ob.isActive = false));
      const country_info = context.state.list.find((ob) => ob.key === country);
      country_info.isActive = true;

      console.log(context.state.list);
    },
    initializeLocale(context) {
      const savedLocale = context.state.selected;
      console.log(savedLocale);

      const hasSavedLocale = context.state.list.some(
        (ob) => ob.key === savedLocale
      );

      context.state.list.forEach((ob) => {
        ob.isActive = false;
        if (hasSavedLocale) {
          ob.isActive = ob.key === savedLocale;
        } else {
          ob.isActive = ob.key === "en";
        }
      });

      // this.currentLocale = "en";
      // this.selectLanguage  = this.list[0].icon;
    },
  },
  getters: {
    getLocaleCookie() {
      // return useCookie('i18n_redirected').value
    },

    globalItems(state) {
      return state.list;
    },
  },
};
